export default __webpack_public_path__ + "static/media/nrc.f76cdd84.jpg";